import routeBuilder from './routes';
const view = {
  layout: 'GridLayout',
  routeBuilder,
};
export default view;
